import React, { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { Button, Card, Input } from "../components/ui"
import { useAuth } from "../contexts/AuthContext"

const LoginPage: React.FC = () => {
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [error, setError] = useState("")
    const { login, loading } = useAuth()
    const navigate = useNavigate()

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        setError("")

        if (!username || !password) {
            setError("Por favor, preencha todos os campos")
            return
        }

        try {
            const success = await login(username, password)
            if (success) {
                navigate("/dashboard")
            } else {
                setError("Credenciais inválidas. Por favor, tente novamente.")
            }
        } catch (err) {
            setError("Ocorreu um erro ao fazer login. Por favor, tente novamente.")
        }
    }

    return (
        <div className="flex min-h-screen flex-col justify-center bg-bg px-4 py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <h2 className="text-center text-3xl font-bold text-text">
                    Nanoplay Admin
                </h2>
                <p className="mt-2 text-center text-sm text-muted">
                    Ou{" "}
                    <Link
                        to="/register"
                        className="font-medium text-primary hover:opacity-80"
                    >
                        crie uma nova conta
                    </Link>
                </p>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <Card>
                    <form className="flex flex-col gap-6" onSubmit={handleSubmit}>
                        {error && (
                            <div className="rounded-lg border border-danger/40 bg-danger-soft p-4">
                                <p className="text-sm text-danger-text">
                                    {error}
                                </p>
                            </div>
                        )}

                        <div>
                            <label
                                htmlFor="username"
                                className="mb-1 block text-sm font-medium text-text"
                            >
                                Nome de usuário
                            </label>
                            <Input
                                id="username"
                                name="username"
                                type="text"
                                autoComplete="username"
                                required
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </div>

                        <div>
                            <label
                                htmlFor="password"
                                className="mb-1 block text-sm font-medium text-text"
                            >
                                Senha
                            </label>
                            <Input
                                id="password"
                                name="password"
                                type="password"
                                autoComplete="current-password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>

                        <Button
                            type="submit"
                            loading={loading}
                            className="w-full"
                        >
                            {loading ? "Entrando..." : "Entrar"}
                        </Button>
                    </form>
                </Card>
            </div>
        </div>
    )
}

export default LoginPage
